import React, { useMemo, useCallback } from 'react';
import { useJobSearchContext } from '../../../contexts/JobSearchContext';
import { JobSearchBar } from './JobSearchBar/JobSearchBar';

export const JobsSearchBarWrapper = () => {
    const {
        setJobsSearch,
        setSingleJobUrl,
        jobsSearch,
        setSelectFirstJob,
        setPage,
        setResetFilters,
        clearFilters,
        setSearchQueryId,
    } = useJobSearchContext();

    const handleSubmit = useCallback(
        ({ keywords, location }) => {
            setSearchQueryId(null);
            setSelectFirstJob(true);
            setSingleJobUrl(null);
            setPage(1);
            // clearFilters();
            // setResetFilters(true);
            setJobsSearch({
                keywords,
                location: location.value,
                lng: location.lng,
                lat: location.lat,
            });
        },
        [
            setSingleJobUrl,
            setJobsSearch,
            setSelectFirstJob,
            setPage,
            setResetFilters,
            clearFilters,
            setSearchQueryId,
        ]
    );

    return useMemo(
        () => (
            <JobSearchBar
                handleSubmit={handleSubmit}
                headerText="Find jobs at companies that want to hire women."
                searchPlaceholder="Search for Job title or Keyword"
                query={jobsSearch?.keywords || ''}
                location={jobsSearch?.location || ''}
            />
        ),
        [handleSubmit, jobsSearch]
    );
};
